import { render, staticRenderFns } from "./WenfangPopup.vue?vue&type=template&id=29a938ba&scoped=true"
import script from "./WenfangPopup.vue?vue&type=script&lang=ts"
export * from "./WenfangPopup.vue?vue&type=script&lang=ts"
import style0 from "./WenfangPopup.vue?vue&type=style&index=0&id=29a938ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a938ba",
  null
  
)

export default component.exports